module.exports = __webpack_public_path__ + "img/camp_icon.18ea453a.png";